import React, { Component } from 'react';

const DEFAULT_BASE_URL = 'https://triviaweekend.com';

const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return window.location.origin;
  }
  return DEFAULT_BASE_URL;
};

const upsertMetaTag = ({ name, property, content }) => {
  if (!content) {
    return;
  }

  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  const attribute = name ? 'name' : 'property';
  const key = name || property;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }

  tag.setAttribute('content', content);
};

const upsertLinkTag = ({ rel, href }) => {
  if (!href) {
    return;
  }

  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', rel);
    document.head.appendChild(tag);
  }
  tag.setAttribute('href', href);
};

const upsertStructuredData = ({ schema, id }) => {
  if (!schema) {
    return;
  }
  const scriptId = id || 'structured-data';
  let script = document.getElementById(scriptId);
  if (!script) {
    script = document.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', scriptId);
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(schema);
};

class Seo extends Component {
  componentDidMount() {
    this.applySeo();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.applySeo();
    }
  }

  applySeo() {
    const {
      title,
      description,
      canonicalPath,
      robots = 'index,follow',
      ogType = 'website',
      schema,
      schemaId,
    } = this.props;
    const baseUrl = getBaseUrl();
    const canonicalUrl = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;

    if (title) {
      document.title = title;
    }

    upsertMetaTag({ name: 'description', content: description });
    upsertMetaTag({ name: 'robots', content: robots });
    upsertMetaTag({ property: 'og:title', content: title });
    upsertMetaTag({ property: 'og:description', content: description });
    upsertMetaTag({ property: 'og:type', content: ogType });
    upsertMetaTag({ property: 'og:url', content: canonicalUrl });
    upsertMetaTag({ property: 'og:site_name', content: 'Trivia Weekend' });
    upsertLinkTag({ rel: 'canonical', href: canonicalUrl });
    upsertStructuredData({ schema, id: schemaId });
  }

  render() {
    return null;
  }
}

export default Seo;
